import { Component} from '@angular/core';
import { faSpinner as falSpinnerThird } from "@fortawesome/free-solid-svg-icons/faSpinner";

@Component({
  standalone: false,
  selector: 'app-loader',
  template: `
    <fa-icon [icon]="loader" animation="spin" size="1x"></fa-icon>
  `
})
export class LoaderComponent {

  loader = falSpinnerThird;

}




